import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { config } from '@app/core/app-config';
import { SignupUserService } from '@app/modules/signup-new/services/signup-user.service';
import { LocalStorageKey, NotificationType } from '@app/shared/interfaces';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { catchError, EMPTY, finalize } from 'rxjs';

@Component({
  selector: 'sbnb-signup-with-airbnb-page',
  templateUrl: './signup-with-airbnb-page.component.html',
})
export class SignupWithAirbnbPageComponent {
  config = config;
  loading: boolean;

  form = new UntypedFormGroup({
    agreed_to_tos: new UntypedFormControl(false, Validators.requiredTrue),
  });

  constructor(
    private signupUserService: SignupUserService,
    private notificationService: ToastNotificationsService
  ) {}

  signUpWithAirbnb() {
    this.loading = true;
    this.signupUserService
      .signUpWithAirbnb()
      .pipe(
        catchError(() => {
          this.notificationService.open(
            'We are unable to redirect you to Airbnb at this time',
            'Dismiss',
            NotificationType.Error
          );
          return EMPTY;
        }),
        finalize(() => (this.loading = false))
      )
      .subscribe((response) => {
        localStorage.setItem(LocalStorageKey.signUpAirbnbStateNew, response.state);
        window.location.href = response.url;
      });
  }
}
